export default "__VITE_ASSET__BCGeFCsO__"